module.exports = __webpack_public_path__ + "img/car_clio_sw.5f9a0112.jpg";